import Settings from '@/views/Dashboard/Settings/Settings.vue';
import Account from '@/views/Dashboard/Settings/Account.vue';
import Profile from '@/views/Dashboard/Settings/Profile.vue';
import Billing from '@/views/Dashboard/Settings/Billing.vue';
import Sites from '@/views/Dashboard/Settings/Sites.vue';

export default [
    {
        path: 'settings',
        component: Settings,
        children: [
            {
                path: '',
                component: Account,
                name: 'Account',
            },
            {
                path: 'profile',
                component: Profile,
            },
            {
                path: 'billing',
                component: Billing,
            },
            {
                path: 'billing/lifetime/:id',
                component: Sites,
            },
            {
                path: 'sites',
                component: Sites,
            },
        ],
    },
];
